<div class="card-body row">
  <div class="col-md-8 col-sm-12 col-xs-12">
    <div class="col-12">
      <span>{{priceDiscovery?.StateName}}</span>
      <p class="commodityName"> {{priceDiscovery?.CommodityName}} ({{priceDiscovery?.TypeName}}) |
        {{priceDiscovery?.PracticeName}} </p>
    </div>
    <div class="row info-row">
      <div class="col-md-3">
        <table class="table">
          <tr>
            <td>Year:</td>
            <td>{{priceDiscovery?.HarvestYear}}</td>
          </tr>
          <tr>
            <td>Type:</td>
            <td>{{priceDiscovery?.TypeName}}</td>
          </tr>
          <tr>
            <td>Practice:</td>
            <td>{{priceDiscovery?.PracticeName}}</td>
          </tr>
        </table>
      </div>
      <div class="col-md-5">
        <table class="table">
          <tr>
            <td>Sales Close:</td>
            <td>{{formatDate()}}</td>
          </tr>
          <tr>
            <td>Exchange:</td>
            <td>{{priceDiscovery?.HarvestPriceExchangeCode}}</td>
          </tr>
          <tr>
            <td>Contract Month:</td>
            <td>{{priceDiscovery?.HarvestMonthName}}</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
  <div class="col-md-4 col-sm-12 col-xs-12 row">
    <div class="col-md-4 d-flex flex-column align-items-center">
      <p class="price-title">Projected Price</p>
      <p class="price-dates">{{formatDates(priceDiscovery?.ProjectedPriceDateRange)}}</p>
      <p class="dollarPrice">{{priceDiscovery?.ProjectedPrice | currency: 'USD' : 'symbol' : '1.2-2'}}</p>
      <p class="price status" [ngClass]="getDiscoveryClass(priceDiscovery.ProjectedPriceStatus)">
        {{priceDiscovery.ProjectedPriceStatus}}</p>
    </div>
    <div class="col-md-4 d-flex flex-column align-items-center">
      <p class="price-title">Volatility Factor</p>
      <p class="price-dates" style="height: 19px !important;"></p>
      <p class="dollarPrice">%{{priceDiscovery?.PriceVolatilityPercentDisplay | number: '1.2-2'}}</p>
      <p class="price status" [ngClass]="getDiscoveryClass(priceDiscovery?.PriceVolatilityStatusDisplay)">
        {{priceDiscovery?.PriceVolatilityStatusDisplay}}</p>
    </div>
    <div class="col-md-4 d-flex flex-column align-items-center">
      <p class="price-title">Harvest Price</p>
      <p class="price-dates">{{formatDates(priceDiscovery?.HarvestPriceDateRange)}}</p>
      <p class="dollarPrice">{{getHarvestPrice(priceDiscovery?.HarvestPrice) | currency : 'USD' : 'symbol' : '1.2-2'}}</p>
      <p class="price status" [ngClass]="getDiscoveryClass(priceDiscovery?.HarvestPriceStatus)">
        {{priceDiscovery?.HarvestPriceStatus}}</p>
    </div>
  </div>
  <div class="collapse" id="{{generatedId()}}" [ngbCollapse]="isCollapsed" style="width: 100%;">
    <app-details [isCollapsed]="isCollapsed" [commodityCode]="priceDiscovery?.CommodityCode"
                 [harvestCode]="priceDiscovery?.HarvestPriceMarketSymbolCodes" [id]="generatedId()"
                 [discoveryDates]="discoveryDates" [stateCode]="priceDiscovery.StateCode"
                 [practiceName]="priceDiscovery?.PracticeName" [harvestMonthName]="priceDiscovery.HarvestMonthName"
                 [typeName]="priceDiscovery.TypeName" [priceFactor]="priceDiscovery?.PriceMultiplicativeFactor"
    [year]="priceDiscovery.CommodityYear" [actuarialDate]="priceDiscovery.ActuarialDate"
    [practiceCode]="priceDiscovery?.PracticeCode" [typeCode]="priceDiscovery?.TypeCode" [harvestStarted]="priceDiscovery?.HarvestPriceStatus"
    [projectedStarted]="priceDiscovery?.ProjectedPriceStatus"></app-details>
  </div>
  <div class="col-md-12 d-flex flex-row justify-content-center" style="margin-top: 30px;">
    <button type="button" class="openDetails" (click)="isCollapsed = !isCollapsed" [attr.aria-expanded]="!isCollapsed"
            [attr.aria-controls]="generatedId()">Details
    </button>
  </div>
</div>
